module.exports = __webpack_public_path__ + "static/p-12-c8477d4243b51c1badd3bd346833a8f5.jpg";